import request from '../request';
import {RequestPageData, RequestReturnPromise, ResponsePageData} from './type';

// @ts-ignore
export function ocrYDBase64(imgBase64) {
  return request({
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    url: '/api-internet-user/mp/one/pad/v1/ocr/question',
    data: {
      question: imgBase64,
    },
  });
}

// @ts-ignore
export function getOCRRecordInfo(recordId) {
  return request({
    url: `/api-internet-user/mp/ai/user/ocr/question/get/${recordId}`,
  });
}

export type OCRRecordListParams = RequestPageData<{}>;
export type OCRRecordListData = {
  ocrDate: string;
  /* */
  records: {
    /* */
    base64Img: string;

    /* */
    ocrRecordId: number;
  }[];
};

export function getOCRRecordList(
  params: OCRRecordListParams,
): RequestReturnPromise<ResponsePageData<OCRRecordListData>> {
  return request({
    url: '/api-internet-user/mp/ai/user/ocr/question/record/page',
    params,
  });
}
